import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IExtraInfo, IExtraInfoOrder } from 'src/app/interfaces/extra-info';
import { IListingDataSourceConfig } from 'src/app/interfaces/listing-data-source-config';

import { ApiService } from '../../../app/services/api.service';
import { ProductInfoList } from '../components/list/component';
import { ProductInfoDataSource } from './product-info-data-source';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProductInfoApiService {
  constructor(
    private Api: ApiService,
    private dialog: MatDialog,
    private commonFunctionService: CommonFunctionService,
    private Http: HttpClient
  ) {}

  public getDataSource(DataSourceConfig: IListingDataSourceConfig) {
    return new ProductInfoDataSource(DataSourceConfig, this, this.Http);
  }

  public list(role: string, productId: number) {
    return new Promise((resolve, reject) => {
      let endpoint = `${role}/listings/${productId}/product-info`;
      const url = this.commonFunctionService.findApiUrl(role);
      setTimeout(() =>
        this.Api.get(endpoint, url).then(
          (ProductInfo: IExtraInfo[]) => resolve(ProductInfo),
          (error) => reject(error)
        )
      );
    });
  }

  public viewList(DataSource: ProductInfoDataSource) {
    const config = new MatDialogConfig();

    config.data = DataSource;
    config.disableClose = true;

    // this is to combat drag drop bug of not working when page is scrolled
    // https://github.com/angular/components/issues/15880
    document.body.scrollTo({ top: 0 });

    return this.dialog.open(ProductInfoList, config);
  }

  public order(
    role: string,
    productId: number,
    ProductInfo: IExtraInfoOrder[]
  ) {
    const endpoint = `${role}/listings/${productId}/product-info-order`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.post(endpoint, ProductInfo, url).then(
      () => this.Api.handleSuccess('Product info reordered'),
      (error) => this.Api.handleError(error)
    );
  }

  public save(
    role: string,
    productId: number,
    ProductInfo: IExtraInfo,
    file: boolean = false
  ) {
    let endpoint = `${role}/listings/${productId}/product-info`;
    file && (endpoint += '?fileProvided=true');
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.put(endpoint, ProductInfo, url);
  }

  public delete(role: string, productId: number, ProductInfo: IExtraInfo) {
    const endpoint = `${role}/listings/${productId}/product-info/${ProductInfo.id}`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.delete(endpoint, url, { title: ProductInfo.title }).then(
      () => this.Api.handleSuccess(ProductInfo.title + ' deleted.'),
      (error) => this.Api.handleError(error)
    );
  }

  public deleteFileFromS3(role: string, extraInfoId: number, fileTitle) {
    const filePath = `${extraInfoId}/${fileTitle}`;
    const encodedKey = encodeURIComponent(filePath);
    const endpoint = `${role}/extra-info/${extraInfoId}/delete-file?key=${encodedKey}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url, { title: fileTitle }).then(
      () => this.Api.handleSuccess(fileTitle + ' deleted.'),
      (error) => this.Api.handleError(error)
    );
  }

  public getExtraInfoPutUrl(
    role: string,
    productId: number,
    contentType: string
  ) {
    const endpoint = `${role}/extra-info/${productId}/add-file`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, { contentType }, url);
  }

  public syncExtraInfo(role: string, productId: number) {
    const endpoint = `${role}/extra-info/${productId}/sync-file`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, {}, url);
  }

  public notify(message: string, ok: boolean = true) {
    if (ok) {
      return this.Api.handleSuccess(message);
    } else {
      return this.Api.handleError(message);
    }
  }
}
